// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e39681d6","845":"82696b79"}[chunkId] + ".chunk.js";
};